import { NotificationCycleRowItem } from '../../list';
import { NOTIFY_TIME_VALUES } from '../constants';
import { NotificationCycleValues } from './types';

type DefaultValueProps = {
  notificationCycle: NotificationCycleRowItem;
};

export const getDefaultValues = ({
  notificationCycle,
}: DefaultValueProps): NotificationCycleValues => {
  const defaultValues: NotificationCycleValues = { ...NOTIFY_TIME_VALUES };
  Object.keys(defaultValues).forEach((key) => {
    // @ts-ignore - accessing dynamic keys safely
    defaultValues[key] = notificationCycle?.[key] ?? defaultValues[key];
  });

  return defaultValues;
};
